var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsEnum, IsNumber, IsOptional, IsString } from 'class-validator';
import { UserFullSizeDto } from '../../user/index.js';
import { FeatureRankingType } from '../enums/feature-ranking-type.enum.js';
export class FeatureRankingFullSizeDto {
    id;
    createdAt;
    updatedAt;
    title;
    description;
    type;
    upvotes;
    users;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], FeatureRankingFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], FeatureRankingFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], FeatureRankingFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], FeatureRankingFullSizeDto.prototype, "title", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], FeatureRankingFullSizeDto.prototype, "description", void 0);
__decorate([
    IsEnum(FeatureRankingType),
    Expose(),
    __metadata("design:type", String)
], FeatureRankingFullSizeDto.prototype, "type", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], FeatureRankingFullSizeDto.prototype, "upvotes", void 0);
__decorate([
    IsArray(),
    Type(() => UserFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], FeatureRankingFullSizeDto.prototype, "users", void 0);
//# sourceMappingURL=feature-ranking.full-size.dto.js.map